var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "container wrapper w-full flex flex-col items-center relative"
    },
    [
      _c("div", {
        staticClass:
          "fixed top-[-301px] right-[-400px] xl:right-[-301px] selector-c z-60 h-[613px] w-[613px] xl:h-[813px] xl:w-[813px]",
        domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "fixed top-[400px] xl:top-[600px] right-[-400px] xl:right-[-301px] selector-c z-50 h-[613px] w-[613px] xl:h-[813px] xl:w-[813px]",
        domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass:
          "fixed top-[1080px] xl:top-[1510px] right-[-400px] xl:right-[-301px] selector-c z-50 h-[613px] w-[613px] xl:h-[813px] xl:w-[813px]",
        domProps: { innerHTML: _vm._s(_vm.svg("circle")) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }